import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import { toast } from "react-toastify";
import instance from "services/axiosServices";

export enum PerfilHierarquico {
  Diretor = 1,
  Superintendente = 2,
  Gerente = 3,
  Corretor = 4,
}

export interface UsuarioHierarquico {
  id: string;
  idUsuario?: string;
  nome: string;
  idLider: string | null;
  idEquipe?: string;
  idEquipeLiderUsuario?: string;
  idCorretor?: string;
}

interface Props extends QueryGlobalInterface {
  perfil: PerfilHierarquico;
  idLider?: string | null;
  palavraChave?: string | null;
  enabled?: boolean;
}

export function useUsuariosPorPerfilHierarquico(props: Props) {
  const fetchData = async (): Promise<UsuarioHierarquico[]> => {
    const params = new URLSearchParams();
    params.append("perfil", String(props.perfil));
    if (props.idLider) params.append("idLider", props.idLider);
    if (props.palavraChave) params.append("palavraChave", props.palavraChave);

    const response = await instance.get(
      `identity/usuario/v1/usuarios-por-perfil-hierarquico?${params.toString()}`
    );
    return response?.data?.data || [];
  };

  return useQuery({
    queryFn: fetchData,
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: props.enabled ?? true,
    onError: (error: any) => {
      toast?.error(
        `Erro ao buscar usuários por perfil. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
  });
}
